import {createAction, props} from "@ngrx/store";
import {MissionDto, StartingMissionDto,} from '@server-models';

export const getMission= createAction(
  '[Tech Mission Create] Get Mission',
  props<{ missionId: number }>()
);

export const getMissionSuccess= createAction(
  '[Tech Mission Create] Get Mission Success',
  props<{ model: MissionDto }>()
);

export const getMissionFail= createAction(
  '[Tech Mission Create] Get Mission Fail',
  props<{ error: Error }>()
);

export const postMission= createAction(
  '[Tech Mission Create] Post Mission',
  props<{ model: StartingMissionDto }>()
);

export const postMissionSuccess= createAction(
  '[Tech Mission Create] Post Mission Success',
  props<{ model: StartingMissionDto }>()
);

export const postMissionFail= createAction(
  '[Tech Mission Create] Post Mission Fail',
  props<{ error: Error }>()
);

export const postFollowUpMission= createAction(
  '[Tech Mission Create] Post Follow Up Mission',
  props<{ missionId: number, model: StartingMissionDto }>()
);

export const postFollowUpMissionSuccess= createAction(
  '[Tech Mission Create] Post Follow Up Mission Success',
  props<{ model: StartingMissionDto }>()
);

export const postFollowUpMissionFail= createAction(
  '[Tech Mission Create] Post Follow Up Mission Fail',
  props<{ error: Error }>()
);


